import script from "./LegalSection.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalSection.vue?vue&type=script&setup=true&lang=js"

import "./LegalSection.vue?vue&type=style&index=0&id=319053e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-319053e8"]])

export default __exports__